import TopBar from "components/Layout/TopBar";
import React, {useEffect, useState} from "react";
import {useNavigate} from 'react-router';
import {ClipLoader} from 'react-spinners';
import MyButton from "../../components/Layout/MyButton";
import useAuthz from "../../hooks/useAuthz";
import {Paper} from "@mui/material";
import MySelect from "../../components/Layout/MySelect";
import AgGrid from "../../components/AgGrid/AgGrid";
import {logError} from "../../components/Utils/FormatData";
import axios from "axios";
import {URL_API} from "../../utils/globalConfig";
import {useAlert} from "react-alert";
import ActionsEPRenderer from "../../components/AgGrid/ActionsEPRenderer";
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const ElementsPatrimoines = (props) => {
	const navigate = useNavigate();
	const [authz, user, profil] = useAuthz();
	const [isLoading, setIsLoading] = useState(false);
	const [needReload, setNeedReload] = useState(false);
	const [heritageElements, setHeritageElements] = useState([]);
	const [selectedValue, setSelectedValue] = useState({filterSelected: 1});
	const agGridOptions = {
		suppressCellSelection: true, suppressHorizontalScroll: false, animateRows: true, rowClassRules: {
			'user-deactivate': function (params) {
				return params.data.deleted === true;
			},
		},
	};
	const frameworkComponents = {actionsEPRenderer: ActionsEPRenderer};
	const columnDefs = [
		{
			headerName: 'Actions',
			field: '',
			flex: 1,
			minWidth: 115,
			sortable: false,
			cellRenderer: 'actionsEPRenderer',
			cellStyle: {'justify-content': 'flex-start'},
			cellRendererParams: {setNeedReloadDatas: setNeedReload},
		},
		{headerName: 'id', field: 'id', flex: 1, sortable: true, minWidth: 100,},
		{headerName: 'reseau', field: 'network', flex: 1, sortable: true, minWidth: 150,},
		{headerName: 'autoroute', field: 'axis', flex: 1, sortable: true, minWidth: 125,},
		{headerName: 'centre', field: 'center', flex: 1, sortable: true, minWidth: 150,},
		{headerName: 'pr', field: 'landmark', flex: 1, sortable: true, minWidth: 100,},
		// {headerName: 'departement', field: 'departement', flex: 1, sortable: true, minWidth: 150,},
		// {headerName: 'commune', field: 'commune', flex: 1, sortable: true, minWidth: 150,},
		// {headerName: 'route', field: 'route', flex: 1, sortable: true, minWidth: 150,},
		{headerName: 'latitude', field: 'latitude', flex: 1, sortable: true, minWidth: 125,},
		{headerName: 'longitude', field: 'longitude', flex: 1, sortable: true, minWidth: 125,},
		{headerName: 'sens', field: 'direction', flex: 1, sortable: true, minWidth: 100,},
		// {headerName: 'axe', field: 'axe', flex: 1, sortable: true, minWidth: 100,},
		{headerName: 'échangeur', field: 'id_oa', flex: 1, sortable: true, minWidth: 200,},
		{headerName: 'type', field: 'type', flex: 1, sortable: true, minWidth: 175,},
		// {headerName: 'charges réglementaires', field: 'weight', flex: 1, sortable: true, minWidth: 200,},
		// {headerName: 'ptac max grue', field: 'ptac_max_grue', flex: 1, sortable: true, minWidth: 150,},
		// {headerName: 'itineraire igm', field: 'itineraire_igm', flex: 1, sortable: true, minWidth: 250,},
		// {headerName: 'rapport ptac seuil igm', field: 'rapport_ptac_seuil_igm', flex: 1, sortable: true, minWidth: 200,},
		// {headerName: 'type itineraire', field: 'type_itineraire', flex: 1, sortable: true, minWidth: 150,},
		// {headerName: 'ptac étudié', field: 'ptac_etudie', flex: 1, sortable: true, minWidth: 150,},
		{headerName: 'longueur', field: 'length', flex: 1, sortable: true, minWidth: 150,},
		{headerName: 'largeur', field: 'width', flex: 1, sortable: true, minWidth: 150,},
		{headerName: 'hauteur', field: 'height', flex: 1, sortable: true, minWidth: 150,},
		{headerName: 'ptac max', field: 'weight', flex: 1, sortable: true, minWidth: 150,},
		// {headerName: 'empietement', field: 'empietement', flex: 1, sortable: true, minWidth: 150,},
		{headerName: 'description', field: 'description', flex: 1, sortable: true, minWidth: 300,},
	];
	const alert = useAlert();

	//#region useEffect

	useEffect(() => {
		document.title = "TE - Gestion des éléments patrimoines";
		loadHeritageElements();
	}, []);
	useEffect(() => {
		if (needReload) {
			loadHeritageElements();
		}
	}, [needReload]);

	//#endregion

	//#region Functions

	const changeSelectValue = (e) => {
		setSelectedValue({...selectedValue, [e.target.name]: e.target.value});
		setNeedReload(true);
	};

	//#endregion

	//#region API

	const loadHeritageElements = () => {
		setIsLoading(true);

		axios({method: 'get', url: `${URL_API}/element-patrimoine/liste-element-patrimoine`, params: {filter: selectedValue.filterSelected}})
			.then((res) => {
				setHeritageElements(res.data);
				setIsLoading(false);
				setNeedReload(false);
			})
			.catch((err) => {
				logError(alert, err);
			});
	}

	//#endregion

	return (
		<div style={{height: '100%'}}>
			<TopBar title='Gestion des éléments patrimoines' className='topbar-contenu' color={props.params.color}
							buttons={
								<div className='topbar-buttons'>
									<MyButton onClick={() => navigate('/panneau-administration/elements-patrimoines/creation')} icon={faPlus}
														label={'Créer un élément patrimoine'}/>
									<MyButton onClick={() => navigate("/panneau-administration")} icon={''} label={'Retour'}/>
								</div>
							}
							filterContainer={
								<>
									<MySelect name={"filterSelected"} label={"Filtre"}
														datas={[{key: 1, value: 'EP activés'}, {key: 2, value: 'EP désactivés'}]}
														value={selectedValue.filterSelected}
														firstValue={{key: 3, value: 'Tous les EP'}} handleChange={(e) => changeSelectValue(e)}/>
								</>
							}
			/>

			< div className='row' style={{margin: 0}}>
				<ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>

				{!isLoading && heritageElements &&
					<Paper style={{width: '100%', borderTop: '1px solid #4db4da'}}>
						<AgGrid
							key={'ag-grid-elements-patrimoine'}
							rowData={heritageElements}
							columnDefs={columnDefs}
							rowHeight={40}
							pagination={true}
							paginationPageSize={25}
							frameworkComponents={frameworkComponents}
							gridOptions={agGridOptions}
							sortable={false}
						/>
					</Paper>}
			</div>
		</div>
	);

}

export default ElementsPatrimoines;
